function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@okee-uikit/react-hooks';
import { FileClass } from './file';
export var FileUpload = function (_Emitter) {
  _inherits(FileUpload, _Emitter);

  var _super = _createSuper(FileUpload);

  function FileUpload() {
    var _this;

    _classCallCheck(this, FileUpload);

    _this = _super.apply(this, arguments);
    _this.files = [];
    _this.filesMap = {};
    _this.input = {
      current: null
    };
    _this.maxLength = -1;
    _this.autoUpload = true;
    _this.name = '';
    _this.uploadUrl = '';
    _this.accept = '';
    _this.multiple = false;
    _this.withCredentials = false;
    _this.headers = {};
    _this.data = {};
    _this.errors = {
      overflowCount: ''
    };
    _this.hasProgress = false;
    return _this;
  }

  _createClass(FileUpload, [{
    key: "init",
    value: function init(input) {
      this.input = input;
    }
  }, {
    key: "initFile",
    value: function initFile(file) {
      var newFile = new FileClass({
        id: file.id,
        file: file.file,
        fileType: file.fileType,
        name: file.name,
        fileStatus: this.autoUpload ? file.fileStatus : "DONE",
        href: file.href
      });
      this.filesMap[newFile.id] = newFile;
      return newFile;
    }
  }, {
    key: "initURLFile",
    value: function initURLFile(file) {
      var newFile = new FileClass({
        id: file.id,
        fileStatus: file.fileStatus,
        fileType: file.fileType,
        url: file.url,
        name: file.name ? file.name : file.url,
        errmsg: file.errmsg ? file.errmsg : '',
        href: file.href
      });
      this.filesMap[newFile.id] = newFile;
      return newFile;
    }
  }, {
    key: "clickInput",
    value: function clickInput() {
      if (this.input.current) {
        this.input.current.click();
      }
    }
  }, {
    key: "addFiles",
    value: function addFiles(files) {
      var _this2 = this;

      if (this.files.length + files.length > this.maxLength && this.maxLength > -1) {
        this.emit('error', {
          type: 'overflowCount',
          message: this.errors.overflowCount
        });
      } else {
        Array.from(files).forEach(function (file) {
          var fileWrapper = _this2.initFile({
            file: file
          });

          _this2.emit('change', {
            type: 'init',
            file: fileWrapper.getBaseFile()
          });
        });
      }
    }
  }, {
    key: "replaceFile",
    value: function replaceFile(id) {
      var _this3 = this;

      var input = document.createElement('input');
      input.type = 'file';
      input.accept = this.accept;

      input.onchange = function (ev) {
        var files = ev.target.files;

        if (files) {
          var file = _this3.filesMap[id];
          file.destroy();
          file.updateFile({
            file: files[0],
            url: '',
            name: file.name,
            fileStatus: "INIT"
          });
          file.setProgress(0);

          var index = _this3.getIndexById(id);

          index > -1 && _this3.emit('change', {
            type: 'update',
            index: index,
            file: file.getBaseFile()
          });
        }
      };

      input.click();
    }
  }, {
    key: "removeFileById",
    value: function removeFileById(id) {
      var index = this.getIndexById(id);
      index > -1 && this.emit('change', {
        type: 'remove',
        index: index,
        file: this.filesMap[id].getBaseFile()
      });
    }
  }, {
    key: "getIndexById",
    value: function getIndexById(id) {
      for (var i = 0; i < this.files.length; i++) {
        if (this.files[i].id === id) {
          return i;
        }
      }

      return -1;
    }
  }, {
    key: "upload",
    value: function upload(file) {
      var _this4 = this;

      file.fileStatus = "LOADING";
      this.emit('file-change', file.id);

      var progressFn = function progressFn(loaded, total) {
        _this4.hasProgress = true;
        var progress = parseFloat((loaded / total * 100).toFixed(2));
        file.setProgress(progress);

        if (progress === 100) {
          file.fileStatus = "DONE";
        }

        _this4.emit('file-change', file.id);
      };

      if (this.customRequest && file.file) {
        if (this.customRequest.length === 3) {
          this.hasProgress = true;
        }

        this.customRequest(file.file, function (response) {
          var index = _this4.getIndexById(file.id);

          _this4.emit('change', {
            type: 'uploaded',
            index: index,
            response: response,
            file: file.getBaseFile()
          });
        }, progressFn);
        file.fileStatus = "LOADING";
        this.emit('file-change', file.id);
        return file;
      }

      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      xhr.responseType = 'json';

      if (xhr.upload && 'onprogress' in xhr.upload) {
        this.hasProgress = true;

        xhr.upload.onprogress = function (e) {
          e.total > 0 && progressFn(e.loaded, e.total);
        };
      } else {
        this.hasProgress = false;
      }

      xhr.onerror = function (ev) {
        var index = _this4.getIndexById(file.id);

        if (index > -1) {
          _this4.emit('change', {
            type: 'uploaded',
            index: index,
            response: xhr.response,
            file: file.getBaseFile()
          });
        }
      };

      xhr.onload = function (res) {
        var index = _this4.getIndexById(file.id);

        if (index > -1) {
          _this4.emit('change', {
            type: 'uploaded',
            index: index,
            response: xhr.response,
            file: file.getBaseFile()
          });
        }
      };

      var data = this.data;

      if (typeof data === 'function') {
        data = data(file.file);
      }

      for (var name in data) {
        if (Object.prototype.hasOwnProperty.call(data, name)) {
          formData.append(name, data[name]);
        }
      }

      formData.append(this.name, file.file);
      xhr.open('post', this.uploadUrl, true);

      for (var _name in this.headers) {
        if (Object.prototype.hasOwnProperty.call(this.headers, _name)) {
          xhr.setRequestHeader(_name, this.headers[_name]);
        }
      }

      xhr.withCredentials = this.withCredentials;
      xhr.send(formData);
      file.request = {
        abort: function abort() {
          xhr.abort();
        }
      };
      return file;
    }
  }, {
    key: "uploadFileById",
    value: function uploadFileById(id) {
      var index = this.getIndexById(id);

      if (index > -1) {
        this.upload(this.files[index]);
      }
    }
  }, {
    key: "isOverMaxLength",
    value: function isOverMaxLength() {
      return this.maxLength >= 0 && this.files.length >= this.maxLength;
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      this.errors = options.errors || {
        overflowCount: ''
      };
      this.maxLength = !options.maxLength && options.maxLength !== 0 ? -1 : options.maxLength;
      this.autoUpload = !!options.autoUpload;
      this.name = options.name || '';
      this.uploadUrl = options.uploadUrl || '';
      this.accept = options.accept || '';
      this.headers = options.headers || {};
      this.withCredentials = options.withCredentials || false;
      this.data = options.data || {};
      this.customRequest = options.customRequest;
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      var _this5 = this;

      var needChange = false;
      var isAllResolved = true;
      var updatedValues = [];

      if (value.length !== this.files.length) {
        needChange = true;
      }

      if (this.maxLength > -1 && value.length > this.maxLength) {
        this.emit('error', {
          type: 'overflowCount',
          message: this.errors.overflowCount
        });
        return;
      }

      value.forEach(function (baseFile) {
        var f = _this5.filesMap[baseFile.id];

        if (!f) {
          if (baseFile.url) {
            updatedValues.push(_this5.initURLFile(baseFile));
            needChange = true;
          } else if (baseFile.file) {
            updatedValues.push(_this5.initFile(baseFile));
            needChange = true;
            _this5.autoUpload && (isAllResolved = false);
          } else {
            throw new Error('初始化时请设置 url 或者 file 对象');
          }
        } else if (_this5.autoUpload && baseFile.fileStatus === "INIT" && f.fileStatus !== "LOADING") {
          updatedValues.push(_this5.upload(f));
          isAllResolved = false;
        } else if (baseFile.fileStatus === "INIT" && f.fileStatus === "LOADING") {
          updatedValues.push(f);
          isAllResolved = false;
        } else if (f.fileStatus === baseFile.fileStatus) {
          updatedValues.push(f.updateFile(baseFile));

          if (f.fileStatus !== "DONE" && f.fileStatus !== "FAIL") {
            isAllResolved = false;
          }
        } else if (baseFile.fileStatus !== f.fileStatus) {
          updatedValues.push(f.updateFile(baseFile));
          needChange = true;

          if (baseFile.fileStatus !== "DONE" && baseFile.fileStatus !== "FAIL") {
            isAllResolved = false;
          }
        }
      });
      this.files = updatedValues;
      needChange && this.emit('files-change', this.files);
      needChange && isAllResolved && this.emit('value-change', this.getBaseFiles());
      this.clearUnusedFiles();
      this.emit('disabled-change', this.isOverMaxLength());
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.files.forEach(function (file) {
        file.destroy();
      });
    }
  }, {
    key: "clearUnusedFiles",
    value: function clearUnusedFiles() {
      var newMap = Object.assign({}, this.filesMap);
      this.files.forEach(function (file) {
        delete newMap[file.id];
      });
      Object.keys(newMap).forEach(function (id) {
        newMap[id].destroy();
        delete newMap[id];
      });
    }
  }, {
    key: "getBaseFiles",
    value: function getBaseFiles() {
      return this.files.map(function (i) {
        return i.getBaseFile();
      });
    }
  }]);

  return FileUpload;
}(Emitter);